import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type MaterialOutputsPublishingTriggerConfiguraMutationVariables = Types.Exact<{
  input: Types.MutationTriggerConfiguraMaterialDatabasePublishInput;
}>;


export type MaterialOutputsPublishingTriggerConfiguraMutation = { __typename: 'Mutation', triggerConfiguraMaterialDatabasePublish: { __typename: 'ConfiguraMaterialDatabasePublishResult', createdTextile: boolean, binding: { __typename: 'ConfiguraMaterialDatabaseBinding', id: string, textileId: string, latestJobTask?: { __typename: 'Job', id: string, state: Types.JobState } | null } } };

export type MaterialOutputsPublishingTriggerConfiguraBatchMutationVariables = Types.Exact<{
  input: Types.MutationTriggerConfiguraMaterialDatabasePublishBatchInput;
}>;


export type MaterialOutputsPublishingTriggerConfiguraBatchMutation = { __typename: 'Mutation', triggerConfiguraMaterialDatabasePublishBatch: Array<{ __typename: 'ConfiguraMaterialDatabasePublishBatchEntry', materialId: string, jobId?: string | null, skippedMessage?: string | null, refusalMessage?: string | null, createdTextile: boolean }> };

export type MaterialOutputsPublishingConfiguraStatusQueryVariables = Types.Exact<{
  materialId: Types.Scalars['ID']['input'];
}>;


export type MaterialOutputsPublishingConfiguraStatusQuery = { __typename: 'Query', material: { __typename: 'Material', id: string, configuraMaterialDatabasePublishState: any }, configuraMaterialDatabaseBindings: Array<{ __typename: 'ConfiguraMaterialDatabaseBinding', id: string, textileId: string, textileVersion?: number | null, lastPublishedAt?: string | null, lastPublishedRevision?: { __typename: 'MaterialRevision', id: string, number: number } | null, latestJobTask?: { __typename: 'Job', id: string, state: Types.JobState } | null } | null> };

export type MaterialOutputsPublishingJobStateQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type MaterialOutputsPublishingJobStateQuery = { __typename: 'Query', job: { __typename: 'Job', id: string, state: Types.JobState, message?: string | null, progress?: number | null } };

export const MaterialOutputsPublishingTriggerConfiguraDocument = gql`
    mutation materialOutputsPublishingTriggerConfigura($input: MutationTriggerConfiguraMaterialDatabasePublishInput!) {
  triggerConfiguraMaterialDatabasePublish(input: $input) {
    binding {
      id
      textileId
      latestJobTask {
        id
        state
      }
    }
    createdTextile
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialOutputsPublishingTriggerConfiguraGQL extends Apollo.Mutation<MaterialOutputsPublishingTriggerConfiguraMutation, MaterialOutputsPublishingTriggerConfiguraMutationVariables> {
    override document = MaterialOutputsPublishingTriggerConfiguraDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialOutputsPublishingTriggerConfiguraBatchDocument = gql`
    mutation materialOutputsPublishingTriggerConfiguraBatch($input: MutationTriggerConfiguraMaterialDatabasePublishBatchInput!) {
  triggerConfiguraMaterialDatabasePublishBatch(input: $input) {
    materialId
    jobId
    skippedMessage
    refusalMessage
    createdTextile
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialOutputsPublishingTriggerConfiguraBatchGQL extends Apollo.Mutation<MaterialOutputsPublishingTriggerConfiguraBatchMutation, MaterialOutputsPublishingTriggerConfiguraBatchMutationVariables> {
    override document = MaterialOutputsPublishingTriggerConfiguraBatchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialOutputsPublishingConfiguraStatusDocument = gql`
    query materialOutputsPublishingConfiguraStatus($materialId: ID!) {
  material(id: $materialId) {
    id
    configuraMaterialDatabasePublishState
  }
  configuraMaterialDatabaseBindings(filter: {materialId: {in: [$materialId]}}) {
    id
    textileId
    textileVersion
    lastPublishedAt
    lastPublishedRevision {
      id
      number
    }
    latestJobTask {
      id
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialOutputsPublishingConfiguraStatusGQL extends Apollo.Query<MaterialOutputsPublishingConfiguraStatusQuery, MaterialOutputsPublishingConfiguraStatusQueryVariables> {
    override document = MaterialOutputsPublishingConfiguraStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialOutputsPublishingJobStateDocument = gql`
    query materialOutputsPublishingJobState($id: ID!) {
  job(id: $id) {
    id
    state
    message
    progress
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialOutputsPublishingJobStateGQL extends Apollo.Query<MaterialOutputsPublishingJobStateQuery, MaterialOutputsPublishingJobStateQueryVariables> {
    override document = MaterialOutputsPublishingJobStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }